import React, {PureComponent} from 'react';

import {toMap} from '../../lib/helpers';
import DateTimeInput from '../../components/DateTimeInput';
import Button from '../../components/Button';
import SideModal from '../../components/SideModal';
import Form from '../../components/Form';
import Input from '../../components/Input';

import Filter from './Filter';
import {isQuestionDeleted} from "../FormBuilderScreen/shared";

class SheetRowFilter extends PureComponent {
  state = {
    filters: this.props.filters ? this.props.filters.filters : [],
    validations: {},
    minDate: this.props.filters ? this.props.filters.minDate : null,
    maxDate: this.props.filters ? this.props.filters.maxDate : null,
    reviewState: this.props.filters ? this.props.filters.reviewState : ''
  };

  handleFilterChange = filter => {
    this.setState(prevState => ({
      filters: [
        ...prevState.filters.filter(f => f.questionId !== filter.questionId),
        filter
      ].filter(f => f.operator !== null),
      validations: Object.keys(prevState.validations).filter(key => key !== filter.questionId).reduce((map, key) => {
        map[key] = prevState.validations[key];
        return map;
      }, {})
    }));
  }

  handleApplyFilters = () => {
    const {template, onApplyFilters} = this.props;
    const {filters, minDate, maxDate, reviewState} = this.state;
    const questionsById = toMap([...template.contextQuestions, ...template.questions], question => question.id);
    const validations = filters.reduce((map, filter) => {
      const messages = Filter.validate(questionsById[filter.questionId], filter);

      if (messages.length > 0) {
        map[filter.questionId] = messages;
      }

      return map;
    }, {});

    if ((minDate && !maxDate) || (!minDate && maxDate)) {
      validations['row_date_range'] = ['Please enter a start date and end date'];
    }

    this.setState({validations});

    if (Object.keys(validations).length > 0) {
      // There was validation issues, so we won't apply any filters.
      return;
    }

    onApplyFilters({and: true, minDate, maxDate, reviewState, filters});
  }

  handleClearFilters = () => {
    this.setState({
      minDate: null,
      maxDate: null,
      reviewState: '',
      filters: [],
      validations: {}
    });
  }

  render() {
    const {template, catalog, open, onClose, showDeleted} = this.props;
    const {filters, validations, minDate, maxDate, reviewState} = this.state;
    const filtersByQuestionId = toMap(filters, filter => filter.questionId);
    const questions = [...template.contextQuestions].sort((a, b) => a.order - b.order)
      .concat([...template.questions].sort((a, b) => a.order - b.order))
      .filter(question => question.type !== 'IMAGE' && question.type !== 'SIGNATURE');

    return (
      <Form onSubmit={this.handleApplyFilters}>
        <SideModal
          title="Filter Data"
          open={open}
          onClose={onClose}
          options={[
            <Button type="submit">Apply Filters</Button>,
            <Button secondary onClick={this.handleClearFilters}>Clear Filters</Button>
          ]}>
          <SideModal.Content>
            <Form.Group>
              <DateTimeInput
                id="filter_start_date"
                label="Date Range"
                placeholder="Start Date"
                date={minDate}
                onChange={minDate => this.setState({minDate})}
                invalid={validations['row_date_range']}
              />
              <DateTimeInput
                placeholder="End Date"
                style={{marginTop: '0.5rem'}}
                date={maxDate}
                onChange={maxDate => this.setState({maxDate})}
                invalid={validations['row_date_range']}
                validationText={validations['row_date_range'] && validations['row_date_range'][0]}
              />
            </Form.Group>
            {template.reviewers.length > 0 && (
              <Form.Group>
                <Input
                  id="filter_review_state"
                  label="Review Status"
                  type="select"
                  value={reviewState}
                  onChange={e => this.setState({reviewState: e.target.value})}>
                  <option value="">All</option>
                  <option value="APPROVED">Approved</option>
                  <option value="REJECTED">Rejected</option>
                  <option value="PENDING">Pending</option>
                </Input>
              </Form.Group>
            )}
            {(!showDeleted ? questions.filter(question => !isQuestionDeleted(question)) : questions).map(question => (
              <Form.Group key={question.id}>
                <Filter
                  question={question}
                  catalog={catalog}
                  filter={filtersByQuestionId[question.id] || emptyFilter(question)}
                  onChange={this.handleFilterChange}
                  validations={validations[question.id] || []}
                />
              </Form.Group>
            ))}
          </SideModal.Content>
        </SideModal>
      </Form>
    );
  }
}

function emptyFilter(question) {
  return {
    questionId: question.id,
    operator: null,
    values: []
  };
}

export default SheetRowFilter;
